import React from "react";
import { FileText, DownloadSimple, Trash } from "@phosphor-icons/react";

export default function AttachmentList({ items, onDelete, onDownload }) {
  if (items.length === 0) {
    return (
      <div className="px-6 py-10 text-center text-sm text-slate-500">
        No files yet.
      </div>
    );
  }
  return (
    <ul className="divide-y divide-slate-100">
      {items.map((a) => (
        <li
          key={a.id}
          className="px-6 py-3 flex items-center justify-between gap-4"
          data-testid={`vendor-att-row-${a.id}`}
        >
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-9 h-9 bg-slate-100 rounded-md flex items-center justify-center text-slate-500">
              <FileText size={18} />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-medium text-slate-900 truncate">
                {a.file_name}
              </div>
              <div className="text-xs text-slate-500">
                {(a.size / 1024).toFixed(1)} KB ·{" "}
                {new Date(a.uploaded_at).toLocaleDateString()}
                {a.po_code && (
                  <span className="ml-2 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-sky-50 text-sky-700" data-testid={`vendor-att-po-${a.id}`}>
                    {a.po_code}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => onDownload(a)}
              className="p-2 rounded-md hover:bg-slate-100 text-slate-600"
              data-testid={`vendor-att-download-${a.id}`}
            >
              <DownloadSimple size={16} />
            </button>
            {onDelete && <button
              onClick={() => onDelete(a.id)}
              className="p-2 rounded-md hover:bg-red-50 text-red-500"
              data-testid={`vendor-att-delete-${a.id}`}
            >
              <Trash size={16} />
            </button>}
          </div>
        </li>
      ))}
    </ul>
  );
}
